import React from 'react'
import { useRouter } from 'next/router'
import { ItemListElements } from 'next-seo/lib/types'

import 'project/polyfill'
import Strings from 'project/localisation'
import SeoContainer, {
  SeoContainerProps,
} from 'components/util/containers/SeoContainer'
import HoxtonMixLogo from 'components/icons/HoxtonMixLogo'
import useWindowSize from 'components/util/useWindowSize'
import { legalStrings } from 'common/strings/legal-strings'
import PartnerHeroBanner from 'components/hero/PartnerHeroBanner'
import { NextPageWithLayout } from '../../types/nextPageWithLayout'
import PageContainer from 'components/util/containers/PageContainer'
import { auHomeBreadcrumb } from 'components/util/containers/Breadcrumbs'
import LegalDocumentSection from 'components/sections/LegalDocumentSection'
import { Tenant } from 'common/tenant'

export type PageType = {}

const Page: NextPageWithLayout<PageType> = () => {
  const size = useWindowSize()

  const { locale } = useRouter()

  const seoProps: SeoContainerProps['seoProps'] = {
    description: legalStrings.seoPrivacyPolicyDescription,
    openGraph: {
      url: 'https://www.hoxtonmix.com/au/privacy-policy/',
    },
    title: `${legalStrings.seoPrivacyPolicyTitle} | HM Australia`,
  }
  const breadcrumb: ItemListElements[] = [
    auHomeBreadcrumb()[0],
    {
      item: 'https://www.hoxtonmix.com/au/privacy-policy/',
      name: `${Strings.privacyPolicy}`,
      position: 2,
    },
  ]
  return (
    <SeoContainer
      alternate={[
        { href: '/privacy-policy', lang: 'en-gb' },
        { href: '/au/privacy-policy', lang: 'en-au' },
      ]}
      breadcrumb={breadcrumb}
      seoProps={seoProps}
    >
      <main className={'overflow-hidden'}>
        <PartnerHeroBanner
          partnershipLogo={
            <HoxtonMixLogo
              className='mb-6 mb-lg-4'
              containerClassName='w-lg-85'
            />
          }
          title='Privacy Policy'
          robotImage={{
            height: 876,
            src: '/images/new/au/robot-holding-mail.png',
            width: 680,
          }}
          imageContainerWidth={size.isLgOrHigher ? '65%' : '100%'}
          description={
            <span>
              How The Hoxton Mix uses and protects the information you provide.
            </span>
          }
        />
        <div className='container'>
          <LegalDocumentSection
            title={legalStrings.privacyPolicyTitle}
            subtitle={legalStrings.privacyPolicySubtitle}
            content={legalStrings.privacyPolicyDescription}
            documentTitle={`${Strings.privacyPolicy}`}
            documentSize={116}
            documentPath={`/privacy_policy_au.pdf`}
            contentStyle={{
              maxWidth: 987,
            }}
          />
        </div>
      </main>
    </SeoContainer>
  )
}
Page.getLayout = (page: React.ReactNode) => (
  <PageContainer tenant={Tenant.AU}>{page}</PageContainer>
)
export default Page
